module.exports = __webpack_public_path__ + "static/media/IconTemplates_-47.4a76d80e.svg";